import * as u from "react";
import { j as v } from "../../../../../../../_virtual/jsx-runtime.js";
function P(e, p = []) {
  let n = [];
  function m(c, t) {
    const o = u.createContext(t);
    o.displayName = c + "Context";
    const r = n.length;
    n = [...n, t];
    const a = (i) => {
      const { scope: d, children: f, ...x } = i, S = d?.[e]?.[r] || o, l = u.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ v.jsx(S.Provider, { value: l, children: f });
    };
    a.displayName = c + "Provider";
    function C(i, d) {
      const f = d?.[e]?.[r] || o, x = u.useContext(f);
      if (x) return x;
      if (t !== void 0) return t;
      throw new Error(`\`${i}\` must be used within \`${c}\``);
    }
    return [a, C];
  }
  const s = () => {
    const c = n.map((t) => u.createContext(t));
    return function(o) {
      const r = o?.[e] || c;
      return u.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: r } }),
        [o, r]
      );
    };
  };
  return s.scopeName = e, [m, _(s, ...p)];
}
function _(...e) {
  const p = e[0];
  if (e.length === 1) return p;
  const n = () => {
    const m = e.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(c) {
      const t = m.reduce((o, { useScope: r, scopeName: a }) => {
        const i = r(c)[`__scope${a}`];
        return { ...o, ...i };
      }, {});
      return u.useMemo(() => ({ [`__scope${p.scopeName}`]: t }), [t]);
    };
  };
  return n.scopeName = p.scopeName, n;
}
export {
  P as createContextScope
};
